import { fromJS, List } from 'immutable'

import {
  CountriesCodesForSelect,
  OrganizationSettings,
  OrganizationSettingsByDomain,
  PromoPage,
} from '../../records/organizationSettings'
import { getIdentityProgress } from 'store/entities/identity/actions'
import {
  fetchOrganizationChildren,
  fetchOrganizationSettingsByDomain,
  fetchOrgPromoPage,
  postOrganizationChildren,
} from './actions'
import * as types from './actionTypes'

export const organizationSettingsState = fromJS({
  entity: new OrganizationSettings(),
  pending: {
    get: false,
    settingsByDomain: true,
    promoPage: false,
  },
  loaded: {
    get: false,
  },
  settingsByDomain: new OrganizationSettingsByDomain(),
  promoPage: new PromoPage(),
  children: [],
})

export default (state = organizationSettingsState, action) => {
  const { type, payload } = action
  switch (type) {
    case types.ORGANIZATION_SETTINGS_SET_PENDING_GET: {
      if (payload != null) {
        return state.setIn(['pending', 'get'], payload.pending)
      }
      return state
    }
    case types.ORGANIZATION_SETTINGS.GET.SUCCESS: {
      if (payload != null) {
        const { data } = payload
        return state.set('entity', new OrganizationSettings(fromJS(data))).setIn(['loaded', 'get'], true)
      }
      return state
    }
    case getIdentityProgress.success.toString(): {
      if (payload && payload.data && payload.data.organization) {
        const { organization } = payload.data
        if (!organization.welcomeEmail) {
          organization.welcomeEmail = {}
        }
        return state.set('entity', new OrganizationSettings(fromJS(organization))).setIn(['loaded', 'get'], true)
      }
      return state
    }
    case fetchOrganizationSettingsByDomain.toString(): {
      return state.setIn(['pending', 'settingsByDomain'], true)
    }
    case fetchOrganizationSettingsByDomain.success.toString(): {
      if (!payload.countriesCodes.length) {
        payload.countriesCodes = [new CountriesCodesForSelect()]
      }
      return state
        .setIn(['pending', 'settingsByDomain'], false)
        .set('settingsByDomain', new OrganizationSettingsByDomain(fromJS(payload)))
    }
    case fetchOrganizationSettingsByDomain.fail.toString(): {
      return state.setIn(['pending', 'settingsByDomain'], false)
    }
    case fetchOrgPromoPage.toString(): {
      return state.setIn(['pending', 'promoPage'], true)
    }
    case fetchOrgPromoPage.success.toString(): {
      return state.setIn(['pending', 'promoPage'], false).set('promoPage', new PromoPage(payload))
    }
    case fetchOrgPromoPage.fail.toString(): {
      return state.setIn(['pending', 'promoPage'], false)
    }
    case fetchOrganizationChildren.toString(): {
      return state.setIn(['pending', 'get'], true)
    }
    case postOrganizationChildren.success.toString():
    case fetchOrganizationChildren.success.toString(): {
      return state.setIn(['pending', 'get'], false).set('children', List(payload.data))
    }
    case fetchOrganizationChildren.fail.toString(): {
      return state.setIn(['pending', 'get'], false)
    }
  }
  return state
}
